import HeaderPageMobile from './container'

export default HeaderPageMobile
